export function getNumberFromModel(value) {
  let sanitizedValue = value.replace(/\./g, '').replace(',', '.');

  return Number(sanitizedValue);
}
